// src/api/auth.js
import API from "../axiosConfig";

export const searchWarningByFilter = async (filters) => {
  try {
    // Construct query parameters based on the provided filters
    const params = {};
    if (filters.matricule) params.matricule = filters.matricule;
    if (filters.reference) params.reference = filters.reference;

    if (filters.type_infraction_id)
      params.type_infraction_id = filters.type_infraction_id;

    if (filters.status) params.status = filters.status;

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }

    if (filters.agent_id) params.agent_id = filters.agent_id;
    if (filters.zone_id) params.zone_id = filters.zone_id;
    if (filters.section_id) params.section_id = filters.section_id;
    if (filters.street_id) params.street_id = filters.street_id;
    if (filters.line_id) params.line_id = filters.line_id;

    // Make a GET request with the filters as query parameters
    const response = await API.get("/warnings/search", { params });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const searchWarningsForPrint = async (matricule, agentId) => {
  const response = await API.get("/warnings/search", {
    params: { matricule, print_search: 1, ...(agentId ? { agent_id: agentId } : {}) },
  });
  return response.data;
};

export const getWarning = async (id, forPrint = false) => {
  try {
    const response = await API.get(`/warnings/${id}`, {
      params: forPrint ? { print_detail: 1 } : undefined,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};


export const cancelWarning = async (id, payload) => {
  try {
    const response = await API.post(`/warnings/${id}/cancel`, payload);
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};
